import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import * as JWT from "jwt-decode";
import { Button } from "reactstrap";
import CsvDownloader from "react-csv-downloader";
import { useParams } from "react-router-dom";
import { UserConsumer } from "../../UserContext";
import Header from "../timesheetModule/Header";
import CalendarView from "./Calender";
import LeavesRecord from "./LeavesRecord";
import PlannedLeaves from "./PlannedLeaves";
import PageLoader from "../../components/PageLoader";
import { EmployeeLeaves_APIs } from "./EmployeeLeavesAPI";
import EmailFormModal from "./EmailFormModal";
import EmployeeStatus from "./EmployeeStatus";
import ButtonComp from "../../components/ButtonComp";

let token = null;

function ManageLeaves(props) {
	const [leaveData, setLeaveData] = useState({});
	const [projectName, setProjectName] = useState("");
	const [loading, setLoading] = useState(true);
	const { id } = useParams();
	const globalState = useContext(UserConsumer);
	let decoded = JWT(globalState.token);

	useEffect(() => {
		if (history?.location?.state?.name) {
			setProjectName(history?.location?.state?.name);
		} else {
			axios
				.get(
					`${EmployeeLeaves_APIs.progectDetails}/${id}/GetProjectDetails`,
					{
						headers: {
							Authorization: `Bearer ${globalState.token}`,
						},
					}
				)
				.then((res) => {
					setProjectName(res.data.projectDetails.projectName);
				});
		}
		axios
			.get(`${EmployeeLeaves_APIs.getProjectTeamLeaves}${id}`, {
				headers: {
					Authorization: `Bearer ${globalState.token}`,
				},
			})
			.then((res) => {
				setLeaveData(res.data);
				setLoading(false);
			})
			.catch((err) => {
				setLeaveData([]);
				setLoading(false);
			});
	}, [globalState.token, history, id]);

	const headers = [
		{ displayName: "Employee", id: "employeeName" },
		{ displayName: "Sick Leaves Available", id: "sickLeaveAvailable" },
		{ displayName: "Sick Leaves Availed", id: "sickLeaveAvailed" },
		{ displayName: "Annual Leave Available", id: "annualLeaveAvailable" },
		{ displayName: "Annual Leave Availed", id: "annualLeaveAvailed" },
		{
			displayName: "Compensation Leave Available",
			id: "compensationLeaveAvailable",
		},
		{
			displayName: "Compensation Leave Availed",
			id: "compensationLeaveAvailed",
		},
	];

	const history = props.history;
	const [toggleEmail, setToggleEmail] = useState(false);
	const [toggleView, setToggleView] = useState(false);
	const [toggleStatusView, setToggleStatusView] = useState(false);
	const csvData1 = leaveData.employeeLeaves?.map((item) => {
		return {
			employeeName: item.name,
			sickLeaveAvailable: item.sickLeaveAvailable,
			sickLeaveAvailed: item.sickLeaveAvailed,
			annualLeaveAvailable: item.annualLeaveAvailable,
			annualLeaveAvailed: item.annualLeaveAvailed,
			compensationLeaveAvailable: item.compensationLeaveAvailable,
			compensationLeaveAvailed: item.compensationLeaveAvailed,
		};
	});
	const styles = {
		display: "flex",
		justifyContent: "flex-end",
	};

	const emailDisplayControl = () => {
		setToggleEmail(!toggleEmail);
	};
	return loading ? (
		<PageLoader />
	) : (
		<div>
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					return (
						<>
							<Header title={projectName} />
							<Button
								className={
									!toggleStatusView
										? "calculatorActiveBtn"
										: "calculator-btn"
								}
								onClick={() => {
									setToggleStatusView(false);
								}}
							>
								Employee Status
							</Button>

							<Button
								className={
									toggleStatusView
										? "calculatorActiveBtn"
										: "calculator-btn"
								}
								onClick={() => {
									setToggleStatusView(true);
								}}
							>
								Team Leaves
							</Button>
							{toggleStatusView && (
								<>
									<div style={styles} className="mt-4 mb-3">
										<ButtonComp
											title={"Send Email"}
											onClick={() => {
												setToggleEmail(!toggleEmail);
											}}
										/>
										<ButtonComp
											title={
												toggleView
													? "Table View"
													: "Calendar View"
											}
											className="ml-2"
											onClick={() => {
												setToggleView(!toggleView);
											}}
										/>

										<CsvDownloader
											filename={`${projectName}.csv`}
											extension=".csv"
											columns={headers}
											datas={csvData1}
											className="primaryButton ml-2"
											style={{ color: "white" }}
											text="Export to Excel"
										/>
									</div>
									{toggleView ? (
										<CalendarView
											eventData={leaveData.plannedLeaves}
										/>
									) : (
										<div>
											<LeavesRecord
												leaveData={
													leaveData.employeeLeaves
												}
											/>
											<PlannedLeaves
												plannedleaveData={
													leaveData.plannedLeaves
												}
											/>
										</div>
									)}
									{toggleEmail && (
										<>
											<div
												className="emailoverlay"
												onClick={emailDisplayControl}
											></div>
											<EmailFormModal
												isEmail={toggleEmail}
												setToggleEmail={
													emailDisplayControl
												}
												ProjectName={projectName}
												ProjectId={id}
												email={decoded.email}
											/>
										</>
									)}
								</>
							)}
							{!toggleStatusView && (
								<EmployeeStatus
									token={globalState.token}
									projectId={id}
								/>
							)}
						</>
					);
				}}
			</UserConsumer>
		</div>
	);
}

export default ManageLeaves;
